import { render, staticRenderFns } from "./AtualizarCliente.vue?vue&type=template&id=f753351e&"
import script from "./AtualizarCliente.vue?vue&type=script&lang=js&"
export * from "./AtualizarCliente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports